

import OnBoardings from "../components/Dashboard/OnBoarding/OnBoardings.vue";
import OnBoarding from "../components/Dashboard/OnBoarding/OnBoarding.vue";
import OnBoardingDetails from "../components/Dashboard/OnBoarding/OnBoardingDetails.vue";
import MerchantOnBoarding from "../components/Dashboard/OnBoarding/MerchantOnBoarding.vue";
import MerchantOnBoardings from "../components/Dashboard/OnBoarding/MerchantOnBoardings.vue";
import MerchantOnBoardingDetails from "../components/Dashboard/OnBoarding/MerchantOnBoardingDetails.vue";

const onboardingRoutes = [
    {
        path: "onBoardings",
        component: OnBoardings,
        meta: {
            required: true,
            roles: ["PanelUser"],
        },
        name: "OnBoardings",
    },
    {
        path: "onBoarding",
        component: OnBoarding,
        roles: ["PanelUser"],
        meta: {
            required: true,
        },
        name: "OnBoarding",
    },
    {
        path: "onBoarding/:id",
        component: OnBoardingDetails,
        meta: {
            required: true,
            roles: ["PanelUser"],
        },
        name: "OnBoardingDetails",
    },
    {
        path: "merchant-onboardings",
        component: MerchantOnBoardings,
        meta: {
            required: true,
            roles: ["PanelUser"],
        },
        name: "MerchantOnBoarding",
    },
    {
        path: "merchant-onboarding/:id",
        component: MerchantOnBoardingDetails,
        meta: {
            required: true,
            roles: ["PanelUser"],
        },
        name: "MerchantOnBoardingDetails",
    },
    {
        path: "merchant-onboarding",
        component: MerchantOnBoarding,
        meta: {
            required: true,
            roles: ["PanelUser"],
        },
        name: "MerchantOnBoardings",
    },
]

export default onboardingRoutes;